import { useState } from "react";
import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";
import { X } from "lucide-react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../config/api";
import axios from "axios";

export default function EditLeadModal({ lead, onClose }) {
  console.log("lead data: ", lead);

  const [status, setStatus] = useState(lead.status);
  const [remark, setRemark] = useState(lead.remark || ""); // prefill if remark exists
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // -------------------------
  // Lead type mapping
  // -------------------------
  const LEAD_TYPE_MAP = {
    2: "company",
    4: "agent",
    5: "retailer",
  };

  const leadTypeName =
    LEAD_TYPE_MAP[
      lead?.lead_type || lead?.type || lead?.leadType || lead?.category
    ] || "agent"; // default fallback

  const sessionUser = JSON.parse(localStorage.getItem("authUserData")) || {};
  const updated_by_id = sessionUser.id;
  const updated_by_name = sessionUser.name || sessionUser.business_name;

  // -------------------------
  // Update lead
  // -------------------------
  const handleUpdate = async () => {

  // ✅ Require remark
  if (
    (status === "lost" ||
      status === "in progress") &&
    !remark.trim()
  ) {

    toast.error(
      "Please enter a remark before updating the lead"
    );

    return;
  }

  setLoading(true);

  try {

    const payload = {
      status,

      remark,

      updated_by_id,

      updated_by_name,
    };

    const response = await axios.post(
      `${BASE_URL}warranty/wlead/status/${lead.id}`,
      payload,
      {
        headers: {
          "Content-Type":
            "application/json",
        },
      }
    );

    const res = response.data;

    if (res?.status) {

      toast.success(
        "Lead updated successfully!"
      );

      onClose();

      // ✅ Redirect
      if (status === "in progress") {

        const typeNumber =
          lead?.lead_type ||
          lead?.type ||
          lead?.leadType ||
          lead?.category ||
          4;

        navigate(
          `/add-entity/${typeNumber}`,
          {
            state: { lead },
          }
        );
      }

    } else {

      toast.error(
        res?.message ||
        "Update failed!"
      );

    }

  } catch (error) {

    toast.error(
      error?.response?.data?.message ||
      "Something went wrong!"
    );

  } finally {

    setLoading(false);

  }
};

  return (
    <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-50">
      <div className="bg-white w-[400px] rounded-2xl p-5 shadow-xl">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-lg font-semibold">Update Lead: {lead.name}</h2>
          <X className="cursor-pointer" onClick={onClose} />
        </div>

        <div className="space-y-3 text-sm">
          {/* Lead Name */}
          <input
            disabled
            value={lead.name}
            className="border px-2 py-1.5 rounded w-full"
          />

          {/* Lead Type */}
          <input
            disabled
            value={leadTypeName}
            className="border px-2 py-1.5 rounded w-full"
          />

          {/* Status */}
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="border px-2 py-1.5 rounded w-full"
          >
            <option value={lead.status}>
              {STATUSES.find((s) => s.value === lead.status)?.label ||
                lead.status}
            </option>

            {lead.status !== "lost" && (
              <option value="lost">
                {STATUSES.find((s) => s.value === "lost")?.label || "Lost"}
              </option>
            )}
            {lead.status !== "in progress" && (
              <option value="in progress">
                {STATUSES.find((s) => s.value === "in progress")?.label ||
                  "In Progress"}
              </option>
            )}
          </select>

          {/* Remark for lost / in progress */}
          {(status === "lost" || status === "in progress") && (
            <textarea
              placeholder={
                status === "lost" ? "Reason for lost" : "Remark for won"
              }
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              className="border px-2 py-1.5 rounded w-full h-20"
            />
          )}
        </div>

        <button
          onClick={handleUpdate}
          disabled={loading}
          className="w-full mt-4 bg-blue-600 text-white py-2 rounded-lg"
        >
          {loading ? "Updating..." : "Update Lead"}
        </button>
      </div>
    </div>
  );
}


// import { useState } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";
// import { X } from "lucide-react";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";

// export default function EditLeadModal({ lead, onClose }) {
//   const [status, setStatus] = useState(lead.status);
//   const [remark, setRemark] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const sessionUser = JSON.parse(localStorage.getItem("authUserData")) || {};
//   const updated_by_id = sessionUser.id;
//   const updated_by_name = sessionUser.name;

//   const handleUpdate = async () => {
//     if (status === "lost" && !remark.trim()) {
//       toast.error("Please enter a reason before marking lead as Lost");
//       return;
//     }

//     setLoading(true);

//     try {
//       const payload = { status, remark, updated_by_id, updated_by_name };
//       const response = await fetch(
//         `${BASE_URL}/warranty/wlead/status/${lead.id}`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         }
//       );

//       const res = await response.json();

//       if (response.ok) {
//         toast.success("Lead updated successfully!");
//         onClose();

//         // ✅ Redirect to AddEntityForm if status is "won"
//         if (status === "won") {
//           // Pass lead data and type via state or query params
//           navigate(`/add-entity/${lead.lead_type}`, { state: { lead } });
//         }
//       } else {
//         toast.error(res.message || "Update failed!");
//       }
//     } catch (error) {
//       toast.error("Something went wrong!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-50">
//       <div className="bg-white w-[400px] rounded-2xl p-5 shadow-xl">
//         <div className="flex justify-between items-center mb-3">
//           <h2 className="text-lg font-semibold">Update Lead: {lead.name}</h2>
//           <X className="cursor-pointer" onClick={onClose} />
//         </div>

//         <div className="space-y-3 text-sm">
//           <input disabled value={lead.name} className="border px-2 py-1.5 rounded w-full" />

//           <select
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//             className="border px-2 py-1.5 rounded w-full"
//           >
//             <option value={lead.status}>
//               {STATUSES.find((s) => s.value === lead.status)?.label || lead.status}
//             </option>

//             {lead.status !== "lost" && (
//               <option value="lost">
//                 {STATUSES.find((s) => s.value === "lost")?.label || "Lost"}
//               </option>
//             )}
//             {lead.status !== "won" && (
//               <option value="won">
//                 {STATUSES.find((s) => s.value === "won")?.label || "Won"}
//               </option>
//             )}
//           </select>

//           {status === "lost" && (
//             <textarea
//               placeholder="Reason for lost"
//               value={remark}
//               onChange={(e) => setRemark(e.target.value)}
//               className="border px-2 py-1.5 rounded w-full h-20"
//             />
//           )}
//         </div>

//         <button
//           onClick={handleUpdate}
//           disabled={loading}
//           className="w-full mt-4 bg-blue-600 text-white py-2 rounded-lg"
//         >
//           {loading ? "Updating..." : "Update Lead"}
//         </button>
//       </div>
//     </div>
//   );
// }




// import { useState } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";
// import { X } from "lucide-react";
// import toast from "react-hot-toast";

// export default function EditLeadModal({ lead, onClose }) {
//   const [status, setStatus] = useState(lead.status);
//   const [remark, setRemark] = useState("");
//   const [loading, setLoading] = useState(false);

//   // Get session user
//   const sessionUser = JSON.parse(localStorage.getItem("authUserData")) || {};
//   const updated_by_id = sessionUser.id;
//   const updated_by_name = sessionUser.name;

//   const handleUpdate = async () => {
//     if (status === "lost" && !remark.trim()) {
//       toast.error("Please enter a reason before marking lead as Lost");
//       return;
//     }

//     setLoading(true);

//     const payload = {
//       status,
//       remark,
//       updated_by_id,
//       updated_by_name,
//     };

//     try {
//       const response = await fetch(
//         `${BASE_URL}/warranty/wlead/status/${lead.id}`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         }
//       );

//       const res = await response.json();
//       setLoading(false);

//       if (response.ok) {
//         toast.success("Lead updated successfully!");
//         onClose();
//       } else {
//         toast.error(res.message || "Update failed!");
//       }
//     } catch (error) {
//       setLoading(false);
//       toast.error("Something went wrong!");
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-50">
//       <div className="bg-white w-[400px] rounded-2xl p-5 shadow-xl">

//         <div className="flex justify-between items-center mb-3">
//           <h2 className="text-lg font-semibold">Update Lead: {lead.name}</h2>
//           <X className="cursor-pointer" onClick={onClose} />
//         </div>

//         <div className="space-y-3 text-sm">
//           <input disabled value={lead.name} className="border px-2 py-1.5 rounded w-full" />

//           <select
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//             className="border px-2 py-1.5 rounded w-full"
//           >
//             {/* Current Status */}
//             <option value={lead.status}>
//               {STATUSES.find((s) => s.value === lead.status)?.label || lead.status}
//             </option>

//             {/* Only show "Lost" if it's not already lost */}
//             {lead.status !== "lost" && (
//               <option value="lost">
//                 {STATUSES.find((s) => s.value === "lost")?.label || "Lost"}
//               </option>
//             )}
//           </select>

//           {status === "lost" && (
//             <textarea
//               placeholder="Reason for lost"
//               value={remark}
//               onChange={(e) => setRemark(e.target.value)}
//               className="border px-2 py-1.5 rounded w-full h-20"
//             />
//           )}
//         </div>

//         <button
//           onClick={handleUpdate}
//           disabled={loading}
//           className="w-full mt-4 bg-blue-600 text-white py-2 rounded-lg"
//         >
//           {loading ? "Updating..." : "Update Lead"}
//         </button>
//       </div>
//     </div>
//   );
// }



// import { useState } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";
// import { X } from "lucide-react";

// export default function EditLeadModal({ lead, onClose }) {
//   const [status, setStatus] = useState(lead.status);
//   const [remark, setRemark] = useState("");
//   const [loading, setLoading] = useState(false);

//   // Get session user
//   const sessionUser = JSON.parse(localStorage.getItem("authUserData")) || {};
//   const updated_by_id = sessionUser.id;
//   const updated_by_name = sessionUser.name;

//   const handleUpdate = async () => {
//     setLoading(true);

//     const payload = {
//       status,
//       remark,
//       updated_by_id,
//       updated_by_name
//     };

//     const response = await fetch(
//       `${BASE_URL}/warranty/wlead/status/${lead.id}`,
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       }
//     );

//     const res = await response.json();
//     setLoading(false);

//     if (response.ok) {
//       alert("Lead Updated");
//       onClose();
//     } else {
//       alert(res.message || "Update failed");
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-50">
//       <div className="bg-white w-[400px] rounded-2xl p-5 shadow-xl">

//         <div className="flex justify-between items-center mb-3">
//           <h2 className="text-lg font-semibold">Update Lead: {lead.name}</h2>
//           <X className="cursor-pointer" onClick={onClose} />
//         </div>

//         <div className="space-y-3 text-sm">
//           <input disabled value={lead.name} className="border px-2 py-1.5 rounded w-full" />

//           <select
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//             className="border px-2 py-1.5 rounded w-full"
//           >
//             {/* Current Status */}
//             <option value={lead.status}>
//               {STATUSES.find((s) => s.value === lead.status)?.label || lead.status}
//             </option>

//             {/* Only show "Lost" if it's not already lost */}
//             {lead.status !== "lost" && (
//               <option value="lost">
//                 {STATUSES.find((s) => s.value === "lost")?.label || "Lost"}
//               </option>
//             )}
//           </select>

//           {status === "lost" && (
//             <textarea
//               placeholder="Reason for lost"
//               value={remark}
//               onChange={(e) => setRemark(e.target.value)}
//               className="border px-2 py-1.5 rounded w-full h-20"
//             />
//           )}
//         </div>

//         <button
//           onClick={handleUpdate}
//           disabled={loading}
//           className="w-full mt-4 bg-blue-600 text-white py-2 rounded-lg"
//         >
//           {loading ? "Updating..." : "Update Lead"}
//         </button>
//       </div>
//     </div>
//   );
// }



// import { useState } from "react";
// import { STATUSES } from "../../Component/EmployeeComponents/STATUSES";
// import { X } from "lucide-react";

// export default function EditLeadModal({ lead, onClose }) {
//   const [status, setStatus] = useState(lead.status);
//   const [remark, setRemark] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleUpdate = async () => {
//     setLoading(true);

//     const response = await fetch(
//       `${BASE_URL}/warranty/wlead/status/${lead.id}`,
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ status, remark }),
//       }
//     );

//     const res = await response.json();
//     setLoading(false);

//     if (response.ok) {
//       alert("Lead Updated");
      
//       onClose();
//     } else {
//       alert(res.message || "Update failed");
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-50">
//       <div className="bg-white w-[400px] rounded-2xl p-5 shadow-xl">

//         <div className="flex justify-between items-center mb-3">
//           <h2 className="text-lg font-semibold">Update Lead: {lead.name}</h2>
//           <X className="cursor-pointer" onClick={onClose} />
//         </div>

//         <div className="space-y-3 text-sm">

//           <input disabled value={lead.name} className="border px-2 py-1.5 rounded w-full" />

//           <select
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//             className="border px-2 py-1.5 rounded w-full"
//             >
//             {/* Current Status (Shown always) */}
//             <option value={lead.status}>
//                 {STATUSES.find((s) => s.value === lead.status)?.label || lead.status}
//             </option>

//             {/* Lost option (only if current status is not already lost) */}
//             {lead.status !== "lost" && (
//                 <option value="lost">
//                 {STATUSES.find((s) => s.value === "lost")?.label || "Lost"}
//                 </option>
//             )}
//             </select>


//           {status === "lost" && (
//             <textarea
//               placeholder="Reason for lost"
//               value={remark}
//               onChange={(e) => setRemark(e.target.value)}
//               className="border px-2 py-1.5 rounded w-full h-20"
//             />
//           )}
//         </div>

//         <button
//           onClick={handleUpdate}
//           disabled={loading}
//           className="w-full mt-4 bg-blue-600 text-white py-2 rounded-lg"
//         >
//           {loading ? "Updating..." : "Update Lead"}
//         </button>
//       </div>
//     </div>
//   );
// }
